import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight, Star } from 'lucide-react';

const PopularCitiesSection = () => {
  const cities = [
    { 
      name: 'Ankara', 
      slug: 'ankara-kombi-servisi', 
      icon: '🏛️',
      services: ['Kombi', 'Klima', 'Beyaz Eşya'],
      ustaCount: 120,
      description: 'Başkentin güvenilir ustalarıyla tanışın'
    },
    { 
      name: 'İstanbul', 
      slug: 'istanbul-kombi-servisi', 
      icon: '🌉',
      services: ['Kombi', 'Klima', 'Elektrik'],
      ustaCount: 250,
      description: 'İstanbul\'un dört bir yanında hizmetinizdeyiz'
    },
    { 
      name: 'İzmir', 
      slug: 'izmir-kombi-servisi', 
      icon: '⚓',
      services: ['Kombi', 'Klima', 'Su Tesisatı'],
      ustaCount: 85,
      description: 'Ege\'nin incisi İzmir\'de kaliteli hizmet'
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#006D77]/10 text-[#006D77] px-4 py-2 rounded-full text-sm font-medium mb-4">
            <MapPin className="w-4 h-4" />
            Hizmet Verdiğimiz Şehirler
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Popüler Şehirler
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Türkiye'nin dört bir yanında onaylı ustalarımızla hizmetinizdeyiz
          </p>
        </div>

        {/* Cities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {cities.map((city) => (
            <Link
              key={city.slug}
              to={`/${city.slug}`}
              className="group bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-xl hover:border-[#006D77]/30 transition-all duration-300 hover:-translate-y-1"
            >
              {/* City Icon */}
              <div className="text-5xl mb-4 text-center">{city.icon}</div>
              
              {/* City Name */}
              <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#006D77] transition-colors mb-2 text-center">
                {city.name}
              </h3>
              
              {/* Description */}
              <p className="text-sm text-gray-500 mb-3 text-center">{city.description}</p>
              
              {/* Usta Count */}
              <div className="flex items-center justify-center gap-1 text-sm text-gray-600 mb-4">
                <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
                <span className="font-semibold">{city.ustaCount}+ Onaylı Usta</span>
              </div>
              
              {/* Services */}
              <div className="flex flex-wrap justify-center gap-2 mb-4">
                {city.services.map((service, idx) => (
                  <span 
                    key={idx}
                    className="text-xs bg-[#006D77]/10 text-[#006D77] px-3 py-1 rounded-full font-medium"
                  >
                    {service}
                  </span>
                ))}
              </div>
              
              {/* CTA Button */}
              <div className="flex items-center justify-center gap-2 text-[#006D77] font-semibold group-hover:text-[#005a63] transition-colors">
                <span>Servis Talep Et</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm mb-4">
            Şehriniz listede yok mu? Endişelenmeyin, Türkiye genelinde hizmet veriyoruz!
          </p>
          <Link 
            to="/servis-talep" 
            className="inline-flex items-center gap-2 bg-[#006D77] text-white px-6 py-3 rounded-xl font-semibold hover:bg-[#005a63] transition-colors"
          >
            <span>Hemen Servis Talep Et</span>
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PopularCitiesSection;
